import { Tooltip as MuiTooltip, type TooltipProps } from '@mui/material';

export type { TooltipProps };

/**
 * Shared tooltip with standardized styling. Renders with an arrow by default;
 * pass `arrow={false}` to opt out.
 *
 * Defaults to `describeChild`, so the title becomes the child's accessible description and
 * the child keeps its own name. Pass `describeChild={false}` only when the child has no
 * text of its own and the title is its name.
 *
 * Uses the popper `fixed` strategy so an open tooltip scrolled off-screen
 * can't extend the document's scroll area and shift the surrounding layout.
 * Note: `fixed` positions relative to the viewport only while the popper is
 * portaled to `document.body` (the default) — avoid combining `disablePortal`
 * with a transformed ancestor.
 */
export const Tooltip = ({
  arrow = true,
  describeChild = true,
  PopperProps,
  children,
  ...props
}: TooltipProps) => (
  <MuiTooltip
    arrow={arrow}
    describeChild={describeChild}
    PopperProps={{
      ...PopperProps,
      popperOptions: { strategy: 'fixed', ...PopperProps?.popperOptions },
    }}
    {...props}
  >
    {children}
  </MuiTooltip>
);
